/**
 * Registre des images uploadees en pleine resolution, indexe par id d'objet
 * canvas (= uuid de l'entite, cf. BasicMapper qui pose `id: model.uuid`).
 *
 * Objectif : generer le fichier d'impression a partir de l'ORIGINAL plein
 * resolution, alors que le canvas d'edition ne porte qu'une version « work »
 * downscalee (2048px WebP) pour la fluidite et la memoire mobile.
 *
 * Mem-smart : on ne stocke que les octets compresses (data URL de l'original,
 * jamais decode ni pose sur le canvas). L'image n'est decodee qu'a l'export,
 * une zone a la fois, puis relachee — la memoire d'edition n'est pas affectee.
 *
 * Invariant de securite : le registre ne doit contenir un original QUE s'il
 * correspond geometriquement au contenu work courant. Toute edition destructive
 * qui remplace le contenu (recadrage, etc.) invalide l'entree (cf. le setter
 * `content` de l'entite Image). Sans cet original synchronise, l'export retombe
 * proprement sur la version work — jamais de rendu faux.
 */
const originals = new Map<string, string>();

/** Enregistre (ou remplace) l'original plein resolution d'une image. */
export function setOriginalImage(id: string | null | undefined, dataUrl: string | null | undefined): void {
    if (!id || !dataUrl) {
        return;
    }
    originals.set(id, dataUrl);
}

/** Original plein resolution d'une image, ou undefined si absent/invalide. */
export function getOriginalImage(id: string | null | undefined): string | undefined {
    if (!id) {
        return undefined;
    }
    return originals.get(id);
}

/** Invalide l'original d'une image (contenu modifie ou calque supprime). */
export function removeOriginalImage(id: string | null | undefined): void {
    if (!id) {
        return;
    }
    originals.delete(id);
}

/** Vide le registre (changement de produit) pour borner la memoire. */
export function clearOriginalImages(): void {
    originals.clear();
}
